export const METRICS_TABLE_QUERY_KEYS = {
  name: 'name.contains',
  type: 'type.contains',
  createdDateStart: 'createdDate.greaterThanOrEqual',
  createdDateEnd: 'createdDate.lessThanOrEqual',
  createdBy: 'createdBy.contains',
};
